import classNames from 'classnames';
import { forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
const styledDropdownMenuCss = "suz0a6i";
export const StyledDropdownMenu = forwardRef((props, ref) => {
  const viewportOffset = {
    left: 260
  };
  const fullWidth = true;
  const pullRight = true;
  return <ViewportDropdownMenu ref={ref} {...props} viewportOffset={viewportOffset} fullWidth={fullWidth} pullRight={pullRight} className={classNames(styledDropdownMenuCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");